import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Play } from "lucide-react";

// Mobile-only quick launcher for the Swipe "screensaver" experience.
// Sits ABOVE the AI FAB so both are always visible and tappable on phones.
export const MobileSwipeFab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname === "/swipe") return null;
  return (
    <button
      data-testid="mobile-swipe-fab"
      onClick={() => navigate("/swipe")}
      aria-label="Open the swipe screensaver"
      className="sm:hidden relative w-12 h-12 rounded-full bg-secondary border border-primary/40 shadow-lg flex items-center justify-center active:scale-95 transition-transform"
    >
      <span
        aria-hidden
        className="w-7 h-7 bg-primary"
        style={{
          WebkitMaskImage: "url(/logo-icon.png)", maskImage: "url(/logo-icon.png)",
          WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
          WebkitMaskSize: "contain", maskSize: "contain",
          WebkitMaskPosition: "center", maskPosition: "center",
        }}
      />
      <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-primary text-primary-foreground flex items-center justify-center border-2 border-background">
        <Play className="w-2 h-2 fill-current" />
      </span>
    </button>
  );
};
